class CustomAccordion {
  constructor(container) {
    this.accordions = container.querySelectorAll("[data-accordion-item]");
    this.isTouchDevice = this.detectTouchDevice();
    this.init();
  }

  detectTouchDevice() {
    return (
      "ontouchstart" in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0
    );
  }

  init() {
    this.accordions.forEach((accordion) => {
      const header = accordion.querySelector(".custom-accordion__header");
      if (!header) return;

      header.addEventListener("click", (e) => {
        if (this.isTouchDevice) e.preventDefault();
        this.toggleAccordion(accordion);
      });
    });
  }

  toggleAccordion(accordion) {
    const isActive = accordion.hasAttribute("data-active");

    this.accordions.forEach((item) => {
      item.removeAttribute("data-active");
      item
        .querySelector(".custom-accordion__header")
        ?.setAttribute("aria-expanded", "false");
    });

    if (!isActive) {
      accordion.setAttribute("data-active", "");
      accordion
        .querySelector(".custom-accordion__header")
        ?.setAttribute("aria-expanded", "true");
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".custom-accordion").forEach((container) => {
    new CustomAccordion(container);
  });
});
